// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-forum-post-edit .fi-forum-post-edit-title {
  margin-bottom: 32px;
}
.fi-forum-post-edit .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-forum/fi-forum-post-edit/fi-forum-post-edit.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGI;EACI,WAAA;AADR","sourcesContent":[".fi-forum-post-edit {\r\n    .fi-forum-post-edit-title {\r\n        margin-bottom: 32px;\r\n    }\r\n\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
